module.exports = __webpack_public_path__ + "static/media/gestalt.279df95e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/posterImgs/gestalt.png
// module id = 420
// module chunks = 0